import React from 'react';
import { parseJwt } from '../../Features/api/apiHelper';

function getCookie(name) {
    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${name}=`);
    if (parts.length === 2) return parts.pop().split(';').shift();
}

export function withAllCookiesTrue(WrappedComponent, cookieNames) {
    return class extends React.Component {
        render() {
            const allCookiesTrue = cookieNames.every((cookieName) => {
                const cookieValue = getCookie(cookieName);
                return cookieValue === 'true';
            });

            if (allCookiesTrue) {
                return <WrappedComponent {...this.props} />;
            } else {
                return null;
            }
        }
    };
}

export function withAnyCookieTrue(WrappedComponent, cookieNames) {
    return class extends React.Component {
        render() {
            const anyCookieTrue = cookieNames.some((cookieName) => {
                const cookieValue = getCookie(cookieName);
                return cookieValue === 'true';
            });

            if (anyCookieTrue) {
                return <WrappedComponent {...this.props} />;
            } else {
                return null;
            }
        }
    };
}

export function withNoCookieTrue(WrappedComponent, cookieNames) {
    return class extends React.Component {
        render() {
            const noCookieTrue = cookieNames.every((cookieName) => {
                const cookieValue = getCookie(cookieName);
                return cookieValue !== 'true';
            });

            if (noCookieTrue) {
                return <WrappedComponent {...this.props} />;
            } else {
                return null;
            }
        }
    };
}

export function checkCookiesExist(cookie_list) {
    for (const cookie_name of cookie_list) {
      const cookie_value = getCookie(cookie_name);
      if (typeof cookie_value !== 'undefined') {
        return true;
      }
    }
    return false;
}

// Who may open each console page. The menu, the launcher cards and the routes all read these,
// so a page is offered only to the groups its backend serves (NEU-1113).
export const CONSOLE_GROUPS = ["global_super_user", "dsm_operator", "dsm_testbench", "neura_ims_admin"];
export const USER_MANAGEMENT_GROUPS = ["global_super_user", "neura_ims_admin"];
// The DSM access-summary endpoint serves global_super_user only.
export const RESIDENTS_ANALYTICS_GROUPS = ["global_super_user"];

// Reads the groups from the access token, not from the `${group}=true` cookies: any cookie can
// be set by hand, and checkCookiesExist only asked whether one was present (NEU-881).
export function hasAnyGroup(groups) {
    const token = getCookie('access');
    const claims = token && parseJwt(token);
    if (!claims || !claims.exp || claims.exp * 1000 <= Date.now()) return false;
    const held = claims.user_groups || [];
    return groups.some((group) => held.includes(group));
}
